export const sortAZText = "Sorted A to Z";
export const sortZAText = "Sorted Z to A";